import { SectionIndexItem } from './components/SectionIndexAutocomplete';

function makeItems(
  tabKey: string,
  tabLabel: string,
  sectionLabel: string,
  sectionId: string,
  labels: string[]
): SectionIndexItem[] {
  return labels.map((label) => ({
    label,
    sectionLabel,
    sectionId,
    tabKey,
    tabLabel,
  }));
}

export const factorsSectionIndex: SectionIndexItem[] = [
  // homogenization
  ...makeItems(
    'homogenization',
    'Homogeneização',
    'Elementos e Homogeneização',
    'fac-homogenization',
    [
      'Item',
      'Preço Total (R$)',
      'Valor Unitário (R$/m²)',
      'Oferta',
      'Fator / Oferta',
      'Valor Homogeneizado (R$/m²)',
    ]
  ),
  ...makeItems('homogenization', 'Homogeneização', 'Fatores', 'fac-factors', [
    'Média',
    'Desvio Padrão',
    'Coeficiente de Variação',
    'Validação de Coeficiente',
    'Coeficiente Utilizado',
  ]),
  ...makeItems(
    'homogenization',
    'Homogeneização',
    'Poder de Predição',
    'fac-graphs',
    ['Poder de predição do modelo - valores unitários dos terrenos']
  ),

  // variation_and_sanitation
  ...makeItems(
    'variation_and_sanitation',
    'Variação e Saneamento',
    'Variação e Saneamento',
    'fac-variation',
    ['Item', 'Valor Saneado', 'Intervalo de Ajuste']
  ),
  ...makeItems(
    'variation_and_sanitation',
    'Variação e Saneamento',
    'Estatísticas',
    'fac-aggregated',
    [
      'Elementos Homogeneizados',
      'Média Homogeneizada',
      'Limite Inferior (-30%)',
      'Limite Superior (+30%)',
      'Elementos Saneados',
      'Média Saneada',
      'Desvio Padrão',
      'T de Student',
      'Limite Máximo',
      'Limite Mínimo',
      'Intervalo de Confiabilidade (%)',
      'Grau de Precisão',
    ]
  ),

  // foundation
  ...makeItems('foundation', 'Fundamentação', 'Fundamentação', 'fac-scores', [
    'Grau',
    'Pontos',
  ]),

  // result
  ...makeItems('result', 'Resultado', 'Resultado da avaliação', 'fac-result', [
    'Valor Unitário Médio',
    'Valor Unitário Mínimo',
    'Valor Unitário Máximo',
    'Valor Total Médio',
    'Valor Total Mínimo',
    'Valor Total Máximo',
    'Amplitude Mínima do Modelo',
    'Amplitude Máximo do Modelo',
  ]),
  ...makeItems('result', 'Resultado', 'Formação do Valor', 'fac-formation', [
    'Área',
    'Valor de Mercado com Arredondamento de +1%',
    'Valor de Mercado com Arredondamento de -1%',
    'Valor de Mercado Arredondado',
  ]),
];

export const inferenceSectionIndex: SectionIndexItem[] = [
  // result
  ...makeItems(
    'result',
    'Resultado da avaliação e data de referência',
    'Resultado da avaliação',
    'inf-result',
    [
      'Valor Unitário Médio',
      'Valor Unitário Mínimo',
      'Valor Unitário Máximo',
      'Valor Total Médio',
      'Valor Total Mínimo',
      'Valor Total Máximo',
      'Amplitude Mínima do Modelo',
      'Amplitude Máximo do Modelo',
      'Valor de Mercado Arredondado',
      'Data de Referência',
    ]
  ),

  // statistics — Resultado Estatístico
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Resultado Estatístico',
    'inf-statistic',
    [
      'Coeficiente de Correlação',
      'Coeficiente de Determinação',
      'Fisher - Snedecor',
      'Significância do Modelo',
    ]
  ),

  // statistics — Resíduos
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Resíduos',
    'inf-residuals',
    ['Curva Normal', 'Modelo']
  ),

  // statistics — Informações Complementares
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Informações Complementares',
    'inf-complementary',
    [
      'Total de Variáveis',
      'Variáveis Utilizadas no Modelo',
      'Total de Dados',
      'Dados Utilizados no Modelo',
    ]
  ),

  // statistics — Outliers
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Outliers',
    'inf-outliers',
    ['Quantidade de Outliers', 'Porcentagem de Outliers']
  ),

  // statistics — Análise de Variância
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Análise de Variância',
    'inf-variance',
    ['Soma dos Quadrados', 'Graus de Liberdade', 'Quadrado Médio', 'F']
  ),

  // statistics — Descrição das Variáveis
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Descrição das Variáveis',
    'inf-variables',
    ['Tipo da Variável', 'Descrição', 'Nome', 'Unidade']
  ),

  // statistics — Testes de Hipótese
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Testes de Hipótese',
    'inf-hypothesis',
    ['Variável', 'Transformação', 'T Obs', 'Significância (%)']
  ),

  // statistics — Equação de Regressão
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Equação de Regressão',
    'inf-equation',
    ['Equação de Regressão']
  ),

  // statistics — Matriz de Correlação
  ...makeItems(
    'statistics',
    'Resultados estatísticos',
    'Matriz de Correlação',
    'inf-correlation',
    ['Matriz de Correlação']
  ),

  // foundation
  ...makeItems('foundation', 'Fundamentação', 'Fundamentação', 'inf-scores', [
    'Grau',
    'Pontos',
  ]),

  // graphs
  ...makeItems('graphs', 'Análise Gráfica', 'Análise Gráfica', 'inf-graphs', [
    'Gráfico de Aderência - Regressão linear',
    'Gráfico de Resíduos - Regressão linear',
    'Gráfico de Aderência à Curva Normal Reduzida',
    'Distância de Cook',
    'Valor Total',
  ]),
];
